export default Object.freeze({
  NEW: 'NEW',
  MEMBER: 'MEMBER',
  SWITCHING: 'SWITCHING',
});
